import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginUser } from '../services/api';

const Login = ({ setIsAuthenticated, setRoleId, setUserId }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await loginUser({ email, password });

      if (response.token) {
        localStorage.setItem('adminToken', response.token);
        localStorage.setItem('roleId', response.role_id);
        localStorage.setItem('userId', response.user_id); // fixed casing for consistency
        localStorage.setItem('user', JSON.stringify(response.user));

        setIsAuthenticated(true);
        setRoleId(Number(response.role_id));
        setUserId(Number(response.user_id));

        // Redirect based on role
        if (response.role_id === 1) {
          navigate('/dashboard');
        } else {
          navigate('/user-profile');
        }
      } else {
        setError('Login successful but no token received.');
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xxl-4 col-xl-5 col-md-6 d-md-block d-none ps-0">
          <div className="login-image">
            <div className="login-logo">
              <h4 className="text-white">Logo</h4>
            </div>
            <div className="login-content">
              <h3 className="text-white head-xs font-600">“Sending money worldwide is now instant, secure, and effortless.”</h3>
              <p className="text-white text-sm font-400 pt-2">Send, receive, and relax — your money’s already there.</p>
            </div>
          </div>
        </div>
        <div className="col-xxl-8 col-xl-7 col-md-6">
          <div className="row vh-100 align-items-center justify-content-center">
            <div className="col-xxl-6 col-xl-10">
              <div className="p-4">
                <div className="text-center pb-4">
                  <h3 className="theme-text-black head-sm font-600 pb-2">Welcome Back To Paytm</h3>
                  <p className="theme-text-color text-sm font-500 pb-2">Securely access your account and manage all your transfers with ease.</p>
                </div>
                {error && (
                  <div className="alert alert-danger text-center py-2" role="alert">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="pb-3">
                    <label htmlFor="email" className="form-label">
                      Email address
                    </label>
                    <input
                      id="email"
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="pb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      id="password"
                      type="password"
                      className="form-control"
                      placeholder="Enter your password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className='pb-5 w-100 text-end'>
                    <Link to="/reset-password" className="text-primary fw-semibold">Forgot Password?</Link>
                  </div>
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="theme-btn justify-content-center"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Signing in...
                        </>
                      ) : (
                        'Sign In'
                      )}
                    </button>
                  </div>
                </form>
                <div className="login-divider">
                  <p>Or</p>
                </div>
                <div className="text-center">
                  <small className="text-muted">
                    Don’t have an account?{' '}
                    <Link to="/register" className="text-primary fw-semibold">
                      Register
                    </Link>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
